import { render, staticRenderFns } from "./AutocompleteReceita.vue?vue&type=template&id=238f4b3b&scoped=true&"
import script from "./AutocompleteReceita.vue?vue&type=script&lang=js&"
export * from "./AutocompleteReceita.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238f4b3b",
  null
  
)

export default component.exports